import BrandIconBR from '@/components/shared/logos/BrandIconBR';
import BrandIconBilka from '@/components/shared/logos/BrandIconBilka';
import BrandIconCarlsJr from '@/components/shared/logos/BrandIconCarlsJr';
import BrandIconFlowr from '@/components/shared/logos/BrandIconFlowr';
import BrandIconFoetex from '@/components/shared/logos/BrandIconFoetex';
import BrandIconNetto from '@/components/shared/logos/BrandIconNetto';
import BrandIconSalling from '@/components/shared/logos/BrandIconSalling';
import BrandLogoBR from '@/components/shared/logos/BrandLogoBR';
import BrandLogoBilka from '@/components/shared/logos/BrandLogoBilka';
import BrandLogoCarlsJr from '@/components/shared/logos/BrandLogoCarlsJr';
import BrandLogoFlowr from '@/components/shared/logos/BrandLogoFlowr';
import BrandLogoFoetex from '@/components/shared/logos/BrandLogoFoetex';
import BrandLogoNetto from '@/components/shared/logos/BrandLogoNetto';
import BrandLogoSalling from '@/components/shared/logos/BrandLogoSalling';
import { algoliaConfig } from '@/configs/algoliaConfig';
import {
  Brand,
  BrandKey,
  BrandProperties,
  OrderConfirmationBrands,
} from '@/configs/brandConfig.interface';
import { brandSiteConfig } from '@/configs/brandSiteConfig';

const brandProperties: readonly BrandProperties[] = [
  {
    key: 'bilka',
    label: 'Bilka',
    idCode: 'BLK',
    logo: BrandLogoBilka,
    icon: BrandIconBilka,
    algoliaIndex: algoliaConfig.bilkaIndex,
    brandSite: brandSiteConfig.bilkaUrl,
    orderConfirmationKey: OrderConfirmationBrands.bilka,

    loyalty: {
      customerProgram: {
        membershipNrKey: 'cpblkMembershipNr',
        signupDateKey: 'cpblkSignupDate',
      },
      storeBoxProgram: 'CPBLK',
      areMemberOffersBurnable: false,
      isWalletAvailable: true,
      isProductDataAvailable: true,
      isRefundAvailable: false,
    },

    orders: true,
  },

  {
    key: 'carlsjr',
    label: "Carl's Jr.",
    idCode: 'CJR',
    logo: BrandLogoCarlsJr,
    icon: BrandIconCarlsJr,
    orderConfirmationKey: OrderConfirmationBrands.unknown,

    loyalty: {
      customerProgram: {
        membershipNrKey: 'cpcjrMembershipNr',
        signupDateKey: 'cpcjrSignupDate',
      },
      areMemberOffersBurnable: true,
      isWalletAvailable: true,
      isProductDataAvailable: true,
      isRefundAvailable: false,
    },

    orders: false,
  },

  {
    key: 'foetex',
    label: 'Føtex',
    idCode: 'FOT',
    logo: BrandLogoFoetex,
    icon: BrandIconFoetex,
    algoliaIndex: algoliaConfig.foetexIndex,
    brandSite: brandSiteConfig.foetexUrl,
    orderConfirmationKey: OrderConfirmationBrands.foetex,

    loyalty: {
      customerProgram: {
        membershipNrKey: 'cpfotMembershipNr',
        signupDateKey: 'cpfotSignupDate',
      },
      storeBoxProgram: 'CPFOT',
      areMemberOffersBurnable: false,
      isWalletAvailable: true,
      isProductDataAvailable: true,
      isRefundAvailable: true,
    },

    orders: true,
  },

  {
    key: 'nettode',
    label: 'Netto DE',
    idCode: 'NDE',
    logo: BrandLogoNetto,
    icon: BrandIconNetto,
    orderConfirmationKey: OrderConfirmationBrands.unknown,

    loyalty: {
      customerProgram: {
        membershipNrKey: 'cpndeMembershipNr',
        signupDateKey: 'cpndeSignupDate',
      },
      areMemberOffersBurnable: false,
      isWalletAvailable: true,
      isProductDataAvailable: true,
      isRefundAvailable: false,
    },

    orders: false,
  },

  {
    key: 'nettodk',
    label: 'Netto DK',
    idCode: 'NDK',
    logo: BrandLogoNetto,
    icon: BrandIconNetto,
    orderConfirmationKey: OrderConfirmationBrands.unknown,

    loyalty: {
      customerProgram: {
        membershipNrKey: 'cpndkMembershipNr',
        signupDateKey: 'cpndkSignupDate',
      },
      storeBoxProgram: 'CPNDK',
      areMemberOffersBurnable: false,
      isWalletAvailable: true,
      isProductDataAvailable: true,
      isRefundAvailable: false,
    },

    orders: false,
  },

  {
    key: 'nettopl',
    label: 'Netto PL',
    idCode: 'NPL',
    logo: BrandLogoNetto,
    icon: BrandIconNetto,
    orderConfirmationKey: OrderConfirmationBrands.unknown,

    loyalty: false,
    orders: false,
  },

  {
    key: 'salling',
    label: 'Salling',
    idCode: 'SAL',
    logo: BrandLogoSalling,
    icon: BrandIconSalling,
    orderConfirmationKey: OrderConfirmationBrands.unknown,

    loyalty: {
      customerProgram: {
        membershipNrKey: 'cpsalMembershipNr',
        signupDateKey: 'cpsalSignupDate',
      },
      areMemberOffersBurnable: false,
      isWalletAvailable: false,
      isProductDataAvailable: false,
      isRefundAvailable: false,
    },

    orders: false,
  },

  {
    key: 'br',
    label: 'BR',
    idCode: undefined,
    logo: BrandLogoBR,
    icon: BrandIconBR,
    algoliaIndex: algoliaConfig.brIndex,
    brandSite: brandSiteConfig.brUrl,
    orderConfirmationKey: OrderConfirmationBrands.br,

    loyalty: false,
    orders: true,
  },

  {
    key: 'flowr',
    label: 'Flowr',
    idCode: undefined,
    logo: BrandLogoFlowr,
    icon: BrandIconFlowr,
    orderConfirmationKey: OrderConfirmationBrands.unknown,

    loyalty: false,
    orders: false,
  },
] as const;

export const brands = brandProperties.map(
  (brand: BrandProperties) => new Brand(brand),
);

export function getBrand(brandKey: BrandKey): Brand;
export function getBrand(brandKey: BrandKey | undefined): Brand | undefined;
export function getBrand(brandKey: BrandKey | undefined): Brand | undefined {
  if (brandKey == undefined) {
    return undefined;
  }

  const brand = brands.find((brand) => brand.key === brandKey);
  if (!brand) {
    throw new Error(`Brand with key '${brandKey}' not found`);
  }
  return brand;
}

export const getSupportedBrandsForLoyalty = (): Brand[] => {
  return brands.filter((brand) => brand.isSupportedForLoyalty);
};

export const getSupportedBrandsForOrders = (): Brand[] => {
  return brands.filter((brand) => brand.isSupportedForOrders);
};

export const getSupportedBrandForOrdersConfirmation = (
  brandKey: string,
): OrderConfirmationBrands => {
  const brand = brands.find((brand) => brand.key === brandKey);
  if (!brand) {
    return OrderConfirmationBrands.unknown;
  }
  return brand.orderConfirmationKey;
};

export const DEFAULT_BRAND = brands[0];

const brandConfig = {
  brands,
  DEFAULT_BRAND,
  getBrand,
  getSupportedBrandsForLoyalty,
  getSupportedBrandsForOrders,
};

export const getAlgoliaIndex = (
  brandKey?: string | null,
): string | undefined => {
  const brand = brandKey
    ? brands.find((brand) => brand.key === (brandKey as BrandKey))
    : undefined;
  return brand?.algoliaIndex;
};

export const getBrandSiteUrl = (
  brandKey: string,
  productId?: string,
): string | undefined => {
  const brand = brands.find((brand) => brand.key === brandKey);
  return productId
    ? `${brand?.brandSite}produkter/${productId}`
    : brand?.brandSite;
};

export default brandConfig;
